"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AMENDMENTS_ID = void 0;
exports.AMENDMENTS_ID = '7DB0788C020F02780A673DC74757F23823FA3014C1866E72CC4CD8B226CD6EF4';
//# sourceMappingURL=Amendments.js.map